import React from 'react'
import styles from './Panel.module.scss'

function Panel({ children, className }) {
  return <div className={`${styles.panel} ${className ? className : ''}`}>{children}</div>
}

export default Panel
